export function wait(dt: number): Promise<void> {
    return new Promise<void>((resolve) => setTimeout(resolve, dt));
}

export function throttle<TFn extends (...args: unknown[]) => unknown>(fn: TFn, delay: number) {
    let lastCall: ReturnType<typeof setTimeout>;
    let lastRan: number;
    return (...args: Parameters<TFn>) => {
        if (!lastRan) {
            fn(...args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastCall);
            lastCall = setTimeout(
                () => {
                    if (Date.now() - lastRan >= delay) {
                        fn(...args);
                        lastRan = Date.now();
                    }
                },
                delay - (Date.now() - lastRan)
            );
        }
    };
}
